import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ConversationModuleState } from 'src/core/states/conversation/conversation-module.state';
import { Observable } from 'rxjs';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { Select } from '@ngxs/store';
import { CompactPlayerComponent } from 'src/ca-shared/player/compact-player/compact-player.component';

@Component({
    selector: 'ca-conversation-video-call-list',
    templateUrl: './video-call-list.component.html',
    styleUrls: ['./video-call-list.component.scss'],
    standalone: false
})
export class VideoCallListComponent implements OnInit {
  @Select(ConversationModuleState.getActiveList)
  activeList$: Observable<number>;

  @Select(ConversationModuleState.getActiveView)
  activeView$: Observable<number>;

  @Input()
  compactPlayer: CompactPlayerComponent;

  viewOptions$: Observable<GenericLookupDto[]>;
  viewOptions: GenericLookupDto[] = [];

  @Output()
  conversationIdChange: EventEmitter<{
    id: number;
  }> = new EventEmitter();

  @Output()
  dataLoaded = new EventEmitter();

  standardListVisible = true;
  constructor() {}

  ngOnInit() {}

  onConversationIdChanged(conversationId) {
    this.conversationIdChange.emit(conversationId);
  }

  onDataLoaded() {
    this.dataLoaded.emit();
  }
}
